/** @format */

import React from "react";

// Takes two props
// ¬ 'children' - React element used as the rendered elements if an error does not occur.
// ¬ 'fallback' - (Optional) React element rendered as a fallback if the rendering of children fails.
type ErrorBoundaryProps = {
  children: React.ReactElement;
  fallback?: React.ReactElement;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  // If the component errors, handle gracefully and warn error.
  static getDerivedStateFromError(error: Error) {
    console.warn(error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // Attempt to render child elements or if errored, use fallback.
  render() {
    if (this.state.hasError) return this.props.fallback || <></>;
    return <>{this.props.children}</>;
  }
}
